<template>
  <div class="hello">
    <h1>ようこそ ラスミン共和国へ</h1>
    <p>ラスミン共和国は、自由と正義を愛する人々によって建国された共和国です。</p>
    <h2>国民の義務</h2>
    <p>日本時間23:45～24:00の間は統合広場に集まらなければなりません</p>
    <p>不正なことを行っている国民を見つけたら通報しなければいけません</p>
    <h2>広場に入る</h2>
    <div class="image">
    </div>
    <p>広場に入ります。あなたの名前を入力してください。</p>
    <el-input placeholder="名前"
        v-model="name"
        @keydown.enter.native="inspect"></el-input>
    <el-button type="primary" class="orange" round v-on:click="inspect">広場へ</el-button>
  </div>
</template>

<script>
import firestore from '../firestore'
import { Message } from 'element-ui'
import firebase from 'firebase'

export default {
  name: 'Immigration',
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      name: ''
    }
  },
  mounted: function () {
  },
  methods: {
    inspect: function (event) {
      if (!this.name) {
        Message.error('あなたがしどろもどろに発した言葉は名前だと認識されませんでした。')
        return
      }
      var docRef = firestore.collection('name-user').doc(this.name)
      const userName = this.name

      const vueInstance = this

      docRef.get().then(function (doc) {
        if (doc.exists) {
          if (doc.data().isPurged) {
            Message.error('この国民は再教育を受けているため使用できません。あなたは他の正しい名前を使わなければいけません。')
            return
          }
        }
        let currentDate
        var request = new XMLHttpRequest()
        request.open('HEAD', window.location.href, true)
        request.send()
        request.onreadystatechange = function () {
          if (this.readyState === 4) {
            firestore.collection('setting').doc('common').get().then(
              function (setting) {
                var serverDate = new Date(request.getResponseHeader('Date'))
                currentDate = new Date(serverDate)
                if (setting.data().debug === false &&
                    (currentDate.getHours() !== 23 ||
                    currentDate.getMinutes() < 45)) {
                  Message.error('時計が壊れていますか？　' +
                                '広場に入ることができるのは23:45～24:00の間だけです。')
                  return
                }
                firestore.collection('name-user').doc(userName).set({
                  name: userName,
                  isPurged: false
                })

                firebase.auth().signInAnonymously().then(function () {
                  localStorage.name = userName
                  vueInstance.$router.push('integrating-park')
                })
              }
            )
          }
        }
      }).catch(function (error) {
        console.log(error)
        Message.error('入国規制中です。')
        error.handled = true
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.hello {
  background-image: url('/static/p0454_s.jpg');
  margin: 15px;
  padding: 20px;
}
h1 {
  background-color: #2c3e50;
  color: #c4c2ad;
}
h1, h2 {
  font-weight: normal;
}
.orange {
  background-color: #e1441b;
  border-color: #e1441b;
}
div.image {
  background-image: url("/static/IMG_1141.png");
  height: 356px;
  background-repeat: no-repeat;
  background-position: 50% 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/Immigration.vue